const ALIGN = 'center'

// 广告指标
export const AD_INDICATOR_DATA = [
  {
    title: '账面消耗',
    key: 'paperConsume',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '实际消耗',
    key: 'realConsume',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '新建计划数',
    key: 'newPlanNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '在跑计划数',
    key: 'runPlanNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '无效消耗',
    key: 'invalidConsume',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '无效消耗率',
    key: 'invalidConsumeRate',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '展示量',
    key: 'pv',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '千次展示成本',
    key: 'profitPvCost',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '点击量',
    key: 'clickNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '点击成本',
    key: 'clickCost',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },

  {
    title: '计划变现人数',
    key: 'watchFinishUserNum',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '计划变现次数',
    key: 'watchFinishCount',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '变现计划曝光量',
    key: 'adExposureCount',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '计划变现人均次数',
    key: 'watchFinishAvgCount',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  }
]
export const BASIC_DATA = [
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '注册数',
    key: 'registerNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '注册成本',
    key: 'registerCost',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '创角账号数',
    key: 'createRoleNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '角色数',
    key: 'newRoleNum',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '账号DAU',
    key: 'dauUser',
    sortable: 'custom',
    align: ALIGN,
    width: 84
  },
  {
    title: '创角账号率',
    key: 'newRoleRate',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '首日付费创角数',
    key: 'payRole1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费成本',
    key: 'payRoleCost1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角充值金额',
    key: 'createRoleMoney1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角ROI',
    key: 'newRoleRoi1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费次数',
    key: 'newRolePayCnt1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日每次付费成本',
    key: 'payRoleEveryCost1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费率',
    key: 'payRoleRate1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日二次付费率',
    key: 'createRolePayTwiceRate',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '首日等级通过率',
    key: 'roleLevelReachNumRate',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角1小时内等级通过率',
    key: 'roleLevelReachOneHourRate',
    sortable: 'custom',
    align: ALIGN,
    width: 152
  },
  {
    title: '新创角累计充值',
    key: 'createRoleTotalMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '新创角累计ROI',
    key: 'createRoleTotalRoi',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计创角付费数',
    key: 'aaaaa',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计创角付费成本',
    key: 'payRoleCostNd',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计创角付费次数',
    key: 'bbbbb',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计每次付费成本',
    key: 'payRoleEveryCostNd',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '新创角累计天数',
    key: 'createRoleDays',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日付费次数',
    key: 'newRoleSevenDayPayCnt',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日每次付费成本',
    key: 'newRoleSevenDayPayCntCost',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '自然时段创角充值金额',
    key: 'natureTimeNewRoleMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '自然时段创角ROI',
    key: 'ccccc',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '总流水',
    key: 'totalMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '转端流水',
    key: 'transMoney',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  }
]
export const RETAIN_DATA = [
  {
    title: '创角账号1日留存',
    key: 'createRoleRetain1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日留存',
    key: 'createRoleRetain2d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日留存',
    key: 'createRoleRetain3d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日留存',
    key: 'createRoleRetain4d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日留存',
    key: 'createRoleRetain5d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日留存',
    key: 'createRoleRetain6d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日留存',
    key: 'createRoleRetain7d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日留存',
    key: 'createRoleRetain15d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日留存',
    key: 'createRoleRetain30d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日留存',
    key: 'createRoleRetain60d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日留存',
    key: 'createRoleRetain90d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日留存',
    key: 'createRoleRetain120d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日留存',
    key: 'createRoleRetain150d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日留存',
    key: 'createRoleRetain180d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日留存',
    key: 'createRoleRetain210d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日留存',
    key: 'createRoleRetain240d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日留存',
    key: 'createRoleRetain270d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日留存',
    key: 'createRoleRetain300d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日留存',
    key: 'createRoleRetain330d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日留存',
    key: 'createRoleRetain360d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  }
]
export const LTV_DATA = [
  {
    title: '创角账号1日LTV',
    key: 'createRoleLtv1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日LTV',
    key: 'createRoleLtv2d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日LTV',
    key: 'createRoleLtv3d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日LTV',
    key: 'createRoleLtv4d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日LTV',
    key: 'createRoleLtv5d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日LTV',
    key: 'createRoleLtv6d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日LTV',
    key: 'createRoleLtv7d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日LTV',
    key: 'createRoleLtv15d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日LTV',
    key: 'createRoleLtv30d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日LTV',
    key: 'createRoleLtv60d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日LTV',
    key: 'createRoleLtv90d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日LTV',
    key: 'createRoleLtv120d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日LTV',
    key: 'createRoleLtv150d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日LTV',
    key: 'createRoleLtv180d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日LTV',
    key: 'createRoleLtv210d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日LTV',
    key: 'createRoleLtv240d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日LTV',
    key: 'createRoleLtv270d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日LTV',
    key: 'createRoleLtv300d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日LTV',
    key: 'createRoleLtv330d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日LTV',
    key: 'createRoleLtv360d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  }
]
export const ROI_DATA = [
  {
    title: '创角账号1日ROI',
    key: 'createRoleRoi1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日ROI',
    key: 'createRoleRoi2d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日ROI',
    key: 'createRoleRoi3d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日ROI',
    key: 'createRoleRoi4d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日ROI',
    key: 'createRoleRoi5d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日ROI',
    key: 'createRoleRoi6d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日ROI',
    key: 'createRoleRoi7d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日ROI',
    key: 'createRoleRoi15d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日ROI',
    key: 'createRoleRoi30d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日ROI',
    key: 'createRoleRoi60d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日ROI',
    key: 'createRoleRoi90d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日ROI',
    key: 'createRoleRoi120d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日ROI',
    key: 'createRoleRoi150d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日ROI',
    key: 'createRoleRoi180d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日ROI',
    key: 'createRoleRoi210d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日ROI',
    key: 'createRoleRoi240d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日ROI',
    key: 'createRoleRoi270d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日ROI',
    key: 'createRoleRoi300d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日ROI',
    key: 'createRoleRoi330d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日ROI',
    key: 'createRoleRoi360d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  }
]
export const PAY_RETAIN_DATA = [
  {
    title: '创角账号1日付费留存',
    key: 'payRoleRetain1d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日付费留存',
    key: 'payRoleRetain2d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日付费留存',
    key: 'payRoleRetain3d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日付费留存',
    key: 'payRoleRetain4d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日付费留存',
    key: 'payRoleRetain5d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日付费留存',
    key: 'payRoleRetain6d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日付费留存',
    key: 'payRoleRetain7d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日付费留存',
    key: 'payRoleRetain15d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日付费留存',
    key: 'payRoleRetain30d',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日付费留存',
    key: 'payRoleRetain60d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日付费留存',
    key: 'payRoleRetain90d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日付费留存',
    key: 'payRoleRetain120d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日付费留存',
    key: 'payRoleRetain150d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日付费留存',
    key: 'payRoleRetain180d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日付费留存',
    key: 'payRoleRetain210d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日付费留存',
    key: 'payRoleRetain240d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日付费留存',
    key: 'payRoleRetain270d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日付费留存',
    key: 'payRoleRetain300d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日付费留存',
    key: 'payRoleRetain330d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日付费留存',
    key: 'payRoleRetain360d',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  }
]

export const LTV_ROI_RETAIN_DATA = [...LTV_DATA, ...ROI_DATA, ...RETAIN_DATA, ...PAY_RETAIN_DATA].map((i) => ({ ...i, checked: true }))

// 再归因
export const RE_ATTR_BASIC_DATA = [...BASIC_DATA].map((i) => {
  return {
    ...i,
    title: `${i.title}_再归因`,
    key: `reAttribution${i.key}`
  }
})
export const RE_ATTR_LTV_ROI_RETAIN_DATA = [...LTV_DATA, ...ROI_DATA, ...RETAIN_DATA, ...PAY_RETAIN_DATA].map((i) => {
  return {
    ...i,
    title: `${i.title}_再归因`,
    key: `reAttribution${i.key}`
  }
})

export const NAVS = [
  {
    label: '计划指标',
    key: 'ad',
    children: [
      {
        label: '计划指标',
        key: 'AD_INDICATOR_DATA'
      }
    ]
  },
  {
    label: '数据指标',
    key: 'data',
    children: [
      {
        label: '基础数据',
        key: 'BASIC_DATA'
      },
      {
        label: 'LTV/ROI/留存数据',
        key: 'LTV_ROI_RETAIN_DATA'
      }
    ]
  },
  {
    label: '再归因指标',
    key: 'reAttribution',
    children: [
      {
        label: '基础数据',
        key: 'RE_ATTR_BASIC_DATA'
      },
      {
        label: 'LTV/ROI/留存数据',
        key: 'RE_ATTR_LTV_ROI_RETAIN_DATA'
      }
    ]
  }
]

export default {
  AD_INDICATOR_DATA,
  BASIC_DATA,
  LTV_ROI_RETAIN_DATA,
  RE_ATTR_BASIC_DATA,
  RE_ATTR_LTV_ROI_RETAIN_DATA
}
